import React  from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Field, FieldArray, arrayMove, } from 'redux-form';

// Components
import {
  RenderField,
  RenderTextareaField,
} from '@zola/zola-ui';
import * as Validations from '../../../common/form/commonValidations';
import SortableMealOptions from './SortableMealOptions/SortableMealOptions';
import SortableRsvpQuestions from './SortableRsvpQuestions/SortableRsvpQuestions';
import {
  RenderHiddenField,
} from '../../../common/form';
import LabelWithActionLink from './LabelWithActionLink';

// Actions
import {
  showSecondaryModal,
  hideSecondaryModal,
} from '../../../../actions/ModalActions';

const EventFormOtherDetails = (props) => {
  const {
    mealOptionCounts,
    rsvpQuestionCounts,
    showOtherDetails,
    onToggleCommonQs,
    onToggleAttireOs,
    onToggleOtherDetails,
    onDeleteRsvpQuestion,
    onReorder,
    onDeleteMealOption,
  } = props;

  return (
    <div className={`event-form__other-details accordion ${showOtherDetails ? '-opened' : ''}`}>
      <div className="accordion__header" onClick={onToggleOtherDetails}>
        <div className="accordion__title">Other Event Details</div>
        <i className={`zolaicon zolaicon-chevron-${showOtherDetails ? 'up' : 'down'}`} />
      </div>
      <div className="accordion__body">
        <Field
          name="attire"
          id="event-attire"
          label={LabelWithActionLink({
            label: 'Attire Suggestions',
            actionFunc: onToggleAttireOs,
            actionName: 'See Common Attire Suggestions'
          })}
          placeholder="This event is black-tie optional. The grass can be soft, so maybe rethink stilettos."
          type="text"
          component={RenderField}
          maxChars={400}
          validate={Validations.MAX_LENGTH_400}
        />
        <Field
          component={RenderHiddenField}
          name="suggested_attire_option_id"
        />
        <Field
          name="note"
          id="event-note"
          label="Note To Guests"
          placeholder="There will be a few light bites in addition to cocktails. Can’t wait to see you!"
          component={RenderTextareaField}
          rows={3}
          maxChars={1000}
          validate={Validations.MAX_LENGTH_1000}
        />
        <FieldArray
          name="meal_options"
          id="meal-options"
          label="Ask For Meal Preferences"
          component={SortableMealOptions}
          mealOptionCounts={mealOptionCounts}
          onDeleteMealOption={onDeleteMealOption}
          useDragHandle
          lockAxis="y"
          onSortEnd={({ oldIndex, newIndex }) => onReorder('meal_options', oldIndex, newIndex)}
          rerenderOnEveryChange
        />
        <FieldArray
          name="rsvp_questions"
          id="rsvp-questions"
          label={LabelWithActionLink({
            label: 'Ask Other RSVP Questions',
            actionFunc: onToggleCommonQs,
            actionName: 'See Common RSVP Questions'
          })}
          component={SortableRsvpQuestions}
          rsvpQuestionCounts={rsvpQuestionCounts}
          onDeleteRsvpQuestion={onDeleteRsvpQuestion}
          useDragHandle
          lockAxis="y"
          onSortEnd={({ oldIndex, newIndex }) => onReorder('rsvp_questions', oldIndex, newIndex)}
          rerenderOnEveryChange
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const selectedId = state.events.events.selectedId || state.website.entities.selectedEntityId;
  const event = state.events.events.byId[selectedId] || state.website.entities.byId[selectedId];

  return {
    selectedId: state.events.events.selectedId || state.website.entities.selectedEntityId,
    mealOptionCounts: selectedId ? event.meal_option_counts : {},
    rsvpQuestionCounts: selectedId ? event.question_answer_counts : {},
  };
};

const mapDispatchToProps = (dispatch) => ({
  onDeleteRsvpQuestion: (rsvpQuestion, deleteAction) => {
    const onConfirmAction = () => {
      deleteAction();
      dispatch(hideSecondaryModal());
    };
    const copy = {
      dek: 'Are you sure you want to delete this RSVP question?',
      warning: 'If you\'ve already collected RSVPs where guests answered this question, their data will be deleted and lost.',
      buttonText: 'Yes, Delete'
    };
    dispatch(showSecondaryModal('CONFIRM_ACTION', { onConfirmAction, copy }, { size: 'md' }));
  },
  onDeleteMealOption: (rsvpQuestion, deleteAction) => {
    const onConfirmAction = () => {
      deleteAction();
      dispatch(hideSecondaryModal());
    };
    const copy = {
      dek: 'Are you sure you want to delete this Meal Option?',
      warning: 'If you\'ve already collected RSVPs where guests selected this Meal Option, their data will be deleted and lost.',
      buttonText: 'Yes, Delete'
    };
    dispatch(showSecondaryModal('CONFIRM_ACTION', { onConfirmAction, copy }, { size: 'md' }));
  },
  onReorder: (fieldName, indexA, indexB) => dispatch(arrayMove('eventForm', fieldName, indexA, indexB)),
});

EventFormOtherDetails.propTypes = {
  mealOptionCounts: PropTypes.shape({}),
  rsvpQuestionCounts: PropTypes.shape({}),
  showOtherDetails: PropTypes.bool,
  onToggleCommonQs: PropTypes.func,
  onToggleAttireOs: PropTypes.func,
  onToggleOtherDetails: PropTypes.func,
  onDeleteRsvpQuestion: PropTypes.func,
  onDeleteMealOption: PropTypes.func,
  onReorder: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EventFormOtherDetails);



// WEBPACK FOOTER //
// ./src/components/manage/common/EventForm/EventFormOtherDetails.jsx